// extracted by mini-css-extract-plugin
export var cardTitle = "_co-1";
export var commentBubble = "_co-e";
export var commentForm = "_co-a";
export var commentInput = "_co-b";
export var commentLabel = "_co-d";
export var commentPrompt = "_co-9";
export var csatCard = "_co-0";
export var feedbackSection = "_co-7";
export var starDisabled = "_co-6";
export var starEmpty = "_co-5";
export var starFilled = "_co-4";
export var starWrapper = "_co-3";
export var starsContainer = "_co-2";
export var submittedComment = "_co-c";
export var thankYouText = "_co-8";